import { jsx as c } from "react/jsx-runtime";
import { e as p, f as e } from "../../vendor-CwFtm_qv.js";
import '../../assets/index7.css';const r = "wYQ1BW_tooltip", s = {
  tooltip: r
}, a = ({ placement: o = "top", children: t }) => /* @__PURE__ */ c(e, { placement: o, className: s.tooltip, children: t }), $ = (o) => p(o);
export {
  a as Tooltip,
  $ as TooltipTrigger
};
//# sourceMappingURL=index.js.map
